import { JarvisWebHttpClient } from '@jarvis/web-http';

const cseExperimentsEndpoint = '/v2/experiments';

export class ExperimentsApi {
  jarvisWebHttpInstance: JarvisWebHttpClient;

  constructor(jarvisWebHttpInstance: JarvisWebHttpClient) {
    this.jarvisWebHttpInstance = jarvisWebHttpInstance;
  }

  public async getExperiment(id: string) {
    console.log('Get Experiment ', id);

    return this.jarvisWebHttpInstance.get({
      url: `${cseExperimentsEndpoint}?ids=${id}`,
    });
  }
}

export default {
  ExperimentsApi,
};
